import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=beda40a2"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beda40a2')) {
      api.createRecord('beda40a2', component.options)
    } else {
      api.reload('beda40a2', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=beda40a2", function () {
      api.rerender('beda40a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UserAvatar.vue"
export default component.exports